export const languageOptions = [
  { value: "en", label: "English" }
  // { value: "es", label: "Española" },
  // { value: "ar", label: "عربي" },
  // { value: "ru", label: "Русский" },
  // { value: "ur", label: "اردو" },
  // { value: "zh", label: "中国人" }
]
